import React from 'react'

import { InputProps, Input } from '../atoms/Input'

export function InputText({
  name,
  value,
  readOnly,
  onChange,
  ...rest
}: InputProps) {
  return (
    <Input
      type="text"
      name={name}
      value={value}
      readOnly={readOnly}
      onChange={onChange}
      {...rest}
    />
  )
}
